<template>
  <span class="bold-cell">{{ text }}</span>
</template>

<script>
export default {
  name: 'BoldCell',
  props: {
    text: {
      type: [String, Number],
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.bold-cell {
  font-weight: bold;
  font-size: 16px;
  color: #494949;
}
</style>
